import React from "react";

/**
 * TechTicker — infinite horizontal marquee of technology names.
 * Two mirrored tracks run simultaneously so the seam is invisible.
 * Animation is pure CSS; no JS, no dependencies.
 */

const ITEMS = [
  "Next.js", "FastAPI", "Node.js", "Docker", "PostgreSQL",
  "Enterprise RAG", "Stripe", "React", "TypeScript", "AWS",
  "Python", "Vector DBs", "Redis", "LangChain", "Tailwind CSS",
];

// Duplicate for a seamless loop
const TRACK = [...ITEMS, ...ITEMS];

const TechTicker = () => (
  <div
    className="relative w-full overflow-hidden py-3 sm:py-4 bg-secondary/40 border-y border-border/50"
    aria-hidden="true"
  >
    {/* Fade edges */}
    <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-24
                    bg-gradient-to-r from-secondary/40 to-transparent z-10" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-24
                    bg-gradient-to-l from-secondary/40 to-transparent z-10" />

    <div className="ticker-track flex items-center gap-0">
      {TRACK.map((label, i) => (
        <span key={i} className="ticker-item flex items-center gap-3 flex-shrink-0">
          <span className="text-xs sm:text-[13px] font-mono font-bold tracking-wider uppercase
                           text-muted-foreground hover:text-primary transition-colors duration-200
                           whitespace-nowrap cursor-default">
            {label}
          </span>
          {/* Separator dot */}
          <span className="w-1 h-1 rounded-full bg-primary/40 flex-shrink-0" />
        </span>
      ))}
    </div>

    <style>{`
      .ticker-track {
        animation: ticker-scroll 32s linear infinite;
        width: max-content;
        will-change: transform;
      }
      .ticker-item {
        padding-inline: 1.25rem;
      }
      @keyframes ticker-scroll {
        from { transform: translateX(0); }
        to   { transform: translateX(-50%); }
      }
      @media (prefers-reduced-motion: reduce) {
        .ticker-track { animation: none; }
      }
    `}</style>
  </div>
);

export default TechTicker;
